module.exports = __webpack_public_path__ + "static/media/pinkBubble.cb8d2d67.png";